import React, { useState, useEffect } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useParams } from 'react-router-dom';

const programs = [
  {
    id: '0',
    shortTitle: 'Shabbos Morning Parsha Class',
    shortSubtitle: 'In-Depth Textual Analysis and Timely Topics with Dr. Danny Wachstock',
    title: 'Shabbos Morning Parsha Class',
    instructor: 'With Dr. Danny Wachstock',
    body: 'Join for in-depth textual analysis of the weekly parsha and timely topics. Shabbos mornings at 8:15 am in the social hall.'
  },
  {
    id: '1',
    shortTitle: 'The Semichas Chaver Program',
    shortSubtitle: 'Innovative, Fast-Paced Practical Halacha with Rabbi Yaakov Berkowitz',
    title: 'Semichas Chaver Program',
    instructor: 'With Rabbi Yaakov Berkowitz (Rosh Kollel, St. Louis Kollel)',
    body: 'Join a worldwide movement right here at our shul! The Semichas Chaver Program is an innovative, fast-paced, and interactive halacha l\'maysa (practical law) learning program in partnership with the Orthodox Union.'
  },
  {
    id: '2',
    shortTitle: 'Daily Parsha Insights',
    shortSubtitle: 'Brief Daily Reflections shared in Shul and via WhatsApp',
    title: 'Daily Parsha',
    instructor: null,
    body: (
      <>
        Brief thoughts on the aliyah of the day shared after davening each morning and shared in the WhatsApp group. To join the group, contact the office.{' '}
        <a href='https://open.spotify.com/show/033yAZmigIVC3hGPe8PEkQ?si=J92Xl5jJQN6sqE8U3skBCg&utm_source=copy-link' target='_blank' rel='noopener noreferrer'>
          Click here to listen to past recordings
        </a>.
      </>
    )
  },
  {
    id: '3',
    shortTitle: 'Daily Halacha',
    shortSubtitle: 'Practical Laws of Daily Living shared in Shul and via WhatsApp',
    title: 'Daily Halacha',
    instructor: null,
    body: (
      <>
        Timely halachic thoughts shared daily in shul between Mincha/Maariv and shared in the WhatsApp group. Topics discussed include halachot of Tefillah and Holidays.{' '}
        <a href='https://open.spotify.com/show/033yBhMcU8s4wg5mw0rINL?si=fhO3hdScR7mqyYaNn-22UQ&utm_source=copy-link' target='_blank' rel='noopener noreferrer'>
          Click here to listen to past recordings
        </a>.
      </>
    )
  },
  {
    id: '4',
    shortTitle: 'Weekly Gemara Shiur',
    shortSubtitle: 'Amud Shavui Gemara Shiur (Tuesday Nights)',
    title: 'Weekly Gemara Shiur',
    instructor: null,
    body: (
      <>
        Tuesday Nights at 8pm (or following Maariv) in the Beit Medrash. In conjunction with the St. Louis Kollel Amud Shavui Program, currently studying Masechet Sotah.{' '}
        Recordings of previous shiurim can be found{' '}
        <a href='https://www.yutorah.org/search/?teacher=83470&collection=14811' target='_blank' rel='noopener noreferrer'>here</a>.
      </>
    )
  },
  {
    id: '5',
    shortTitle: "Women's Rosh Chodesh Shiur",
    shortSubtitle: 'Monthly Gatherings on Inspiring and Timely Torah Topics',
    title: "Women's Rosh Chodesh Shiur",
    instructor: null,
    body: 'A monthly shiur for women on timely topics.'
  },
  {
    id: '6',
    shortTitle: 'Men\'s "Brew Crew" Shiur',
    shortSubtitle: 'Torah, Chevra, and Chill in Rotating Community Homes',
    title: "Men's Brew Crew Shiur",
    instructor: null,
    body: 'At rotating homes, this shiur provides men of the community the opportunity to enjoy Torah, Chevra and Chill.'
  },
  {
    id: '7',
    shortTitle: 'Weekly Dvar Torah Sheet',
    shortSubtitle: 'Parsha Summaries, Parsha Riddles, and Contemporary Shailos',
    title: 'Weekly Dvar Torah Sheet',
    instructor: null,
    body: 'Published weekly, this sheet provides summaries of the Divrei Torah shared throughout the week on the Parsha. Included is also a parsha riddle and questions and answers of interesting timely shailos.'
  }
];

const Learning = () => {
  const { currentTab } = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState();

  const tabs = [''];

  useEffect(() => {
    setActiveTabIndex(!currentTab ? 0 : tabs.findIndex((el) => el === currentTab));
  }, []);

  const handleTabChange = (newTabIndex) => {
    setActiveTabIndex(newTabIndex);
    if (newTabIndex === 0) {
      window.history.replaceState(null, null, '/learning');
    } else {
      window.history.replaceState(null, null, `/learning/${tabs[newTabIndex]}`);
    }
  };

  return (
    <>
      <div className='page-header text-center d-flex container-fluid justify-content-center align-items-center'>
        <h1>Learning</h1>
      </div>
      <TabView
        className='mt-1 nav-ribbon'
        activeIndex={activeTabIndex}
        onTabChange={(e) => handleTabChange(e.index)}
        scrollable
      >
        <TabPanel header='Learning at YI'>
          <Container className='py-4'>
            <Row className='justify-content-center text-center mb-4'>
              <Col lg={9}>
                <p>
                  Torah learning is at the heart of Young Israel of St. Louis. Explore our regular programming below and click any item to learn more.
                </p>
              </Col>
            </Row>
            <Row className='justify-content-center'>
              <Col lg={9}>
                <Accordion>
                  {programs.map((program) => (
                    <AccordionTab
                      key={program.id}
                      header={
                        <span style={{ fontSize: '1.05rem', textDecoration: 'none' }}>
                          <strong style={{ color: '#212529' }}>{program.shortTitle}</strong>
                          <span style={{ color: '#6c757d', marginLeft: '0.5rem' }}>/ {program.shortSubtitle}</span>
                        </span>
                      }
                    >
                      {program.instructor && (
                        <p className='text-muted mb-2'><em>{program.instructor}</em></p>
                      )}
                      <p className='mb-0'>{program.body}</p>
                    </AccordionTab>
                  ))}
                </Accordion>
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col>
                <p className='mb-0 text-center'>
                  Questions about a specific class or shiur? Email{' '}
                  <a href='mailto:info@youngisrael-stl.org'>info@youngisrael-stl.org</a>.
                </p>
              </Col>
            </Row>
          </Container>
        </TabPanel>
      </TabView>
    </>
  );
};

export default Learning;
